import React from 'react';
import './index.css';

function ArrowButton({ text = '', afterText = '', onClick, className = '', size = 'normal', variant = 'default', disabled = false }) {
  const sizeClass = size === 'large' ? 'arrow-button-large' : 'arrow-button-normal';
  const variantClass = variant === 'special' ? 'arrow-button-special' : '';
  const disabledClass = disabled ? 'arrow-button-disabled' : '';
  
  return (
    <button 
      className={`arrow-button ${sizeClass} ${variantClass} ${disabledClass} ${className}`} 
      onClick={onClick}
      disabled={disabled}
    >
      <span className="arrow-button-text" data-after-text={afterText}>{text}</span>
      <span className="arrow-circle">
        <span className="arrow-icon" style={{ backgroundImage: 'url(/image/黑箭头.png)' }}></span>
      </span>
    </button>
  );
}

export default ArrowButton;

